export default "__VITE_ASSET__ce680a57__"